export default "__VITE_ASSET__fa65f1ab__"